import { Maximize2 } from "lucide-react";
import { VIDEO_NAME, YOUTUBE_EMBED_URL } from "../content/demoVideo";

type FlowTheaterProps = {
  activeTag: string;
  currentSecond: number;
  formatClock: (second: number) => string;
  onExpand?: () => void;
  startSecond?: number;
};

export default function FlowTheater({
  activeTag,
  currentSecond,
  formatClock,
  onExpand,
  startSecond = 0,
}: FlowTheaterProps) {
  const iframeSrc =
    startSecond > 0
      ? `${YOUTUBE_EMBED_URL}?autoplay=1&rel=0&start=${startSecond}`
      : `${YOUTUBE_EMBED_URL}?rel=0`;

  return (
    <section className="animate-fade-up mt-5 rounded-2xl border border-border bg-bg-secondary/80 p-4 shadow-2xl backdrop-blur-md md:p-5">
      <div className="mb-2.5 flex flex-wrap items-center justify-between gap-2 sm:gap-3">
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-text-faint">
          <span className="h-2 w-2 rounded-full bg-green" />
          Live Flow Theater
        </div>
        <div className="flex items-center gap-2">
          <div className="inline-flex h-8 items-center justify-center rounded-full border border-primary-border bg-primary-dim px-3 text-xs font-semibold text-primary-text shadow-sm">
            {activeTag}
          </div>
          {onExpand && (
            <button
              type="button"
              onClick={onExpand}
              className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-border bg-bg-secondary text-text-faint transition hover:border-primary-border hover:text-text"
              aria-label="Expand video"
            >
              <Maximize2 className="h-3.5 w-3.5" />
            </button>
          )}
        </div>
      </div>

      <div className="relative overflow-hidden rounded-xl border border-border bg-black">
        <div className="relative aspect-video">
          <iframe
            src={iframeSrc}
            title={VIDEO_NAME}
            className="h-full w-full border-0"
            referrerPolicy="strict-origin-when-cross-origin"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
      <div className="mt-2.5 flex flex-col gap-1 text-xs text-text-faint sm:flex-row sm:items-center sm:justify-between">
        <span>
          Current stage: <span className="font-semibold text-text">{activeTag}</span>
        </span>
        <span>{formatClock(currentSecond)}</span>
      </div>
    </section>
  );
}
